import { ACCESS_TOKEN_NAME, JSON_CONTENT_TYPE } from '../constant/constants';
import { IApiParams } from '../interface/IApiParams';
import { getApi } from './getApi';

export const apiPayMemmoryConfirm = async (userId: string, appId: string) => {
  const params: IApiParams = {
    url: `api/payMemmoryConfirm.php?uid=${userId}&appid=${appId}`,
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      'Access-Token': localStorage.getItem(ACCESS_TOKEN_NAME),
    },
  };
  return getApi(params, 'GET');
};
